import { Table } from '@features/powerpoint';
import { theme } from '@features/executive-report/domain/theme';
import { TopData } from './top-data-from-report';
import { tableRows } from './table-rows';

export const table = (topData: TopData): Table => {
  const rows = tableRows(topData);

  return {
    tableRows: rows,
    options: {
      fontSize: 14,
      color: theme.colors.white,
      h: 4.9,
      w: 6.81,
      x: 0.5,
      y: 1.44,
      colW: [3, 2, 1],
      valign: 'middle',
    },
  };
};
